import {
  getBrandList,
  getGoodsList,
  getInciList,
  getProductList,
  getConceptList,
  getFormulationList,
  getDocumentList,
  getTrendList,
  getMediaList,
  getSuggest
} from '@/axios/api/search'
import { i18n } from '@/lang/i18n'
const UPDATE_BRAND = 'UPDATE_BRAND'
const UPDATE_KEYWORD = 'UPDATE_KEYWORD'
const UPDATE_GOODS = 'UPDATE_GOODS'
const UPDATE_INCI = 'UPDATE_INCI'
const UPDATE_PRODUCT = 'UPDATE_PRODUCT'
const UPDATE_CONCEPT = 'UPDATE_CONCEPT'
const UPDATE_FORMULATION = 'UPDATE_FORMULATION'
const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT'
const UPDATE_TREND = 'UPDATE_TREND'
const UPDATE_MEDIA = 'UPDATE_MEDIA'
const UPDATE_PAGER = 'UPDATE_PAGER'
const UPDATE_MODULE = 'UPDATE_MODULE'
const UPDATE_SUGGEST_LIST = 'UPDATE_SUGGEST_LIST'
const UPDATE_MODULE_NAME = 'UPDATE_MODULE_NAME'

function createPager () {
  return {
    current: 1,
    size: 10,
    total: 0,
    realTotal: 0
  }
}

const state = {
  module: '',
  keyword: '',
  brand: { list: [], pager: createPager() },
  goods: { list: [], pager: createPager() },
  inci: { list: [], pager: createPager() },
  product: { list: [], pager: createPager() },
  concept: { list: [], pager: createPager() },
  formulation: { list: [], pager: createPager() },
  trend: { list: [], pager: createPager() },
  document: { list: [], pager: createPager() },
  media: { list: [], pager: createPager() },
  suggestList: [],
  moduleList: [
    {
      label: 'search.searchBrand',
      value: 'brandList',
      module: 'brand'
    },
    {
      label: 'search.searchBrand',
      value: 'brandDetail',
      module: 'brand'
    },
    {
      label: 'search.searchBASFProduct',
      value: 'basfProductList',
      module: 'product'
    },
    {
      label: 'search.searchBASFProduct',
      value: 'basfProductDetail',
      module: 'product'
    },
    {
      label: 'search.searchFormulation',
      value: 'formulationList',
      module: 'formulation'
    },
    {
      label: 'search.searchFormulation',
      value: 'formulationDetail',
      module: 'formulation'
    },
    {
      label: 'search.searchIngredient',
      value: 'ingredientSelectList',
      module: 'inci'
    },
    {
      label: 'search.searchIngredient',
      value: 'ingredientSelectDetail',
      module: 'inci'
    },
    {
      label: 'search.searchProducts',
      value: 'productList',
      module: 'goods'
    },
    {
      label: 'search.searchProducts',
      value: 'productDetail',
      module: 'goods'
    },
    {
      label: 'search.searchConcept',
      value: 'conceptIndex',
      module: 'concept'
    },
    {
      label: 'search.searchConcept',
      value: 'conceptDetail',
      module: 'concept'
    },
    {
      label: 'search.searchTrend',
      value: 'trendIndex',
      module: 'trend'
    },
    {
      label: 'search.searchTrend',
      value: 'trendDetail',
      module: 'trend'
    },
    {
      label: 'search.searchVideo',
      value: 'categoryDetail',
      module: 'media'
    },
    {
      label: 'search.searchVideo',
      value: 'videoDetail',
      module: 'media'
    },
    {
      label: 'search.searchVideo',
      value: 'media',
      module: 'media'
    },
    {
      label: 'search.searchDocuments',
      value: 'document',
      module: 'document'
    },
    {
      label: 'search.searchEvent',
      value: 'eventList',
      module: 'event'
    },
    {
      label: 'search.searchEvent',
      value: 'eventDetail',
      module: 'event'
    }
  ],
  moduleName: ''
}

const getters = {
  module: state => state.module,
  keyword: state => state.keyword || '',
  listData: state => {
    return state.module !== 'general'
      ? state[state.module].list
      : []
  },
  pager: state => {
    return state.module !== 'general'
      ? state[state.module].pager
      : []
  },
  total: state => {
    return (state.brand.pager.realTotal || state.brand.pager.total) +
      (state.goods.pager.realTotal || state.goods.pager.total) +
      (state.inci.pager.realTotal || state.inci.pager.total) +
      (state.product.pager.realTotal || state.product.pager.total) +
      (state.concept.pager.realTotal || state.concept.pager.total) +
      (state.formulation.pager.realTotal || state.formulation.pager.total) +
      (state.document.pager.realTotal || state.document.pager.total) +
      (state.trend.pager.realTotal || state.trend.pager.total) +
      (state.media.pager.realTotal || state.media.pager.total)
  },
  brand: state => state.brand.list,
  goods: state => state.goods.list,
  inci: state => state.inci.list,
  product: state => state.product.list,
  concept: state => state.concept.list,
  formulation: state => state.formulation.list,
  trend: state => state.trend.list,
  document: state => state.document.list,
  media: state => state.media.list,
  suggestList: state => state.suggestList,
  moduleList: state => state.moduleList,
  moduleName: state => state.moduleName
}

const mutations = {
  [UPDATE_BRAND] (state, brand) {
    state.brand = { ...state.brand, list: brand || [] }
  },
  [UPDATE_GOODS] (state, goods) {
    state.goods = { ...state.goods, list: goods || [] }
  },
  [UPDATE_INCI] (state, inci) {
    state.inci = { ...state.inci, list: inci || [] }
  },
  [UPDATE_PRODUCT] (state, product) {
    state.product = { ...state.product, list: product || [] }
  },
  [UPDATE_CONCEPT] (state, concept) {
    state.concept = { ...state.concept, list: concept || [] }
  },
  [UPDATE_FORMULATION] (state, formulation) {
    state.formulation = { ...state.formulation, list: formulation || [] }
  },
  [UPDATE_DOCUMENT] (state, document) {
    state.document = { ...state.document, list: document || [] }
  },
  [UPDATE_TREND] (state, trend) {
    state.trend = { ...state.trend, list: trend || [] }
  },
  [UPDATE_MEDIA] (state, media) {
    state.media = { ...state.media, list: media || [] }
  },
  [UPDATE_PAGER] (state, { pager, module }) {
    // if (state.module === 'general') return
    let current = module ? state[module] : state[state.module]
    current.pager = { ...current.pager, ...pager }
  },
  [UPDATE_MODULE] (state, module) {
    state.module = module
  },
  [UPDATE_KEYWORD] (state, keyword) {
    state.keyword = keyword
  },
  [UPDATE_SUGGEST_LIST] (state, suggestList) {
    state.suggestList = suggestList || []
  },
  [UPDATE_MODULE_NAME] (state, moduleName) {
    state.moduleName = moduleName || ''
  }
}

const actions = {
  async getAllListApi ({ dispatch }, { keyword, isReset }) {
    await Promise.all([
      dispatch('getBrandApi', { keyword, isReset }),
      dispatch('getGoodsApi', { keyword, isReset }),
      dispatch('getInciApi', { keyword, isReset }),
      dispatch('getProductApi', { keyword, isReset }),
      dispatch('getConceptApi', { keyword, isReset }),
      dispatch('getFormulationApi', { keyword, isReset }),
      dispatch('getDocumentApi', { keyword, isReset }),
      dispatch('getTrendApi', { keyword, isReset }),
      dispatch('getMediaApi', { keyword, isReset })
    ]).then(res => {
      return true
    }).catch(e => {
      console.log(e)
      return false
    })
  },
  // 获取各模块表格入口
  async getListDataApi ({ state, dispatch }, keyword) {
    const current = state.module
    if (current === 'general') {
      await dispatch('getAllListApi', { keyword, isReset: true })
    } else {
      const dispatchName = current.replace(current[0], current[0].toUpperCase())
      await dispatch(`get${dispatchName}Api`, { keyword, isReset: false })
    }
  },
  // 获取brand列表
  async getBrandApi ({ state, commit }, { keyword, isReset = false }) {
    let { current, size } = { ...state.brand.pager }
    current = isReset ? 1 : current
    try {
      const { data: res } = await getBrandList({
        size,
        current,
        // orderBy: 'hit_num',
        keyword: keyword
      })
      const pager = { total: res.total || 0, current, realTotal: res.realTotal || res.total }
      const module = 'brand'
      commit(UPDATE_PAGER, { pager, module })
      commit(UPDATE_BRAND, res.data)
    } catch (e) { }
  },
  // 获取goods列表
  async getGoodsApi ({ state, commit }, { keyword, isReset = false }) {
    let { current, size } = { ...state.goods.pager }
    current = isReset ? 1 : current
    try {
      const { data: res } = await getGoodsList({
        size,
        current,
        orderBy: 'sort',
        keyword: keyword
      })
      const pager = { total: res.total || 0, current, realTotal: res.realTotal || res.total }
      const module = 'goods'
      commit(UPDATE_PAGER, { pager, module })
      commit(UPDATE_GOODS, res.list)
    } catch (e) {
      console.log(e)
    }
  },
  // 获取Inci列表
  async getInciApi ({ state, commit }, { keyword, isReset = false }) {
    let { current, size } = { ...state.inci.pager }
    current = isReset ? 1 : current
    try {
      const { data: res } = await getInciList({
        areaId: '',
        categoryId: '',
        functionClaimId: '',
        functionId: '',
        size,
        current,
        // orderBy: 'last_quarter_hit_num', // 后台要求固定传这个字段，前端无意义
        keyWord: keyword
      })
      const pager = { total: res.total || 0, current, realTotal: res.realTotal || res.total }
      const module = 'inci'
      commit(UPDATE_PAGER, { pager, module })
      commit(UPDATE_INCI, res.list)
    } catch (e) { }
  },
  // 获取product列表
  async getProductApi ({ state, commit }, { keyword, isReset = false }) {
    let { current, size } = { ...state.product.pager }
    current = isReset ? 1 : current
    try {
      const { data: res } = await getProductList({
        deliveryFormId: '',
        function: '',
        segmentId: '',
        size,
        current,
        desc: ['approveTime'],
        keyWord: keyword
      })
      const pager = { total: res.total || 0, current, realTotal: res.realTotal || res.total }
      const module = 'product'
      commit(UPDATE_PAGER, { pager, module })
      commit(UPDATE_PRODUCT, res.list)
    } catch (e) { }
  },
  // 获取concept列表
  async getConceptApi ({ state, commit }, { keyword, isReset = false }) {
    let { current, size } = { ...state.concept.pager }
    current = isReset ? 1 : current
    try {
      const { data: res } = await getConceptList({
        size,
        current,
        desc: ['approveTime'],
        keyWord: keyword,
        type: 'New'
      })
      const pager = { total: res.total || 0, current, realTotal: res.realTotal || res.total }
      const module = 'concept'
      commit(UPDATE_PAGER, { pager, module })
      commit(UPDATE_CONCEPT, res.list)
    } catch (e) { }
  },
  // 获取formulation列表
  async getFormulationApi ({ state, commit }, { keyword, isReset = false }) {
    let { current, size } = { ...state.formulation.pager }
    current = isReset ? 1 : current
    try {
      const { data: res } = await getFormulationList({
        categoryId: '',
        functionClaimId: '',
        inciIdMust: '',
        inciIdMustNot: '',
        tradeNameIdMust: '',
        tradeNameIdMustNot: '',
        size,
        current,
        keyword: keyword
      })
      const pager = { total: res.total || 0, current, realTotal: res.realTotal || res.total }
      const module = 'formulation'
      commit(UPDATE_PAGER, { pager, module })
      commit(UPDATE_FORMULATION, res.list)
    } catch (e) { }
  },
  // trend
  async getTrendApi ({ state, commit }, { keyword, isReset = false }) {
    let { current, size } = { ...state.trend.pager }
    current = isReset ? 1 : current
    try {
      const { data: res } = await getTrendList({
        size,
        current,
        keyword: keyword
      })
      const pager = { total: res.total || 0, current, realTotal: res.realTotal || res.total }
      const module = 'trend'
      commit(UPDATE_PAGER, { pager, module })
      commit(UPDATE_TREND, res.data)
    } catch (e) { }
  },
  // 获取document列表
  async getDocumentApi ({ state, commit }, { keyword, isReset = false }) {
    let { current, size } = { ...state.document.pager }
    current = isReset ? 1 : current
    try {
      const { data: res } = await getDocumentList({
        size,
        current,
        keyword: keyword
      })
      const pager = { total: res.total || 0, current, realTotal: res.realTotal || res.total }
      const module = 'document'
      commit(UPDATE_PAGER, { pager, module })
      commit(UPDATE_DOCUMENT, res.data)
    } catch (e) { }
  },
  // 获取media列表
  async getMediaApi ({ state, commit }, { keyword, isReset = false }) {
    let { current, size } = { ...state.media.pager }
    current = isReset ? 1 : current
    try {
      const { data: res } = await getMediaList({
        size,
        current,
        keyword: keyword,
        desc: ['created_at']
      })
      const pager = { total: res.total || 0, current, realTotal: res.realTotal || res.total }
      const module = 'media'
      commit(UPDATE_PAGER, { pager, module })
      commit(UPDATE_MEDIA, res.data)
    } catch (e) { }
  },
  setPagerApi ({ commit }, pager) {
    commit(UPDATE_PAGER, { pager })
  },
  setModuleApi ({ commit }, params) {
    commit(UPDATE_MODULE, params)
  },
  setKeywordApi ({ commit }, params) {
    commit(UPDATE_KEYWORD, params)
  },
  // 获取搜索建议列表
  async getSuggestApi ({ commit }, params) {
    try {
      const { data: res } = await getSuggest(params.type, params.data)
      commit(UPDATE_SUGGEST_LIST, res)
      return res
    } catch (e) {
      return []
    }
  },
  setModuleNameApi ({ commit }, params) {
    commit(UPDATE_MODULE_NAME, params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js